import {
    Divider,
    BreadcrumbLink,
    VStack,
    Box,
    HStack,
    Grid,
    GridItem,
    Text,
    IconButton,
    Icon,
    Button,
    ButtonGroup,
    Center,
} from '@chakra-ui/react';
import { ChatLayoutViewProps } from './chatLayoutProps';
import React from 'react';
import { ReportingShellViewBaseConfig } from '../../../base';
import { ChatDetailContainerProps } from '../detail';
import { AiOutlineClose, AiOutlineWarning } from 'react-icons/ai';
import { AiOutlinePlus } from 'react-icons/ai';
import { ChatErrorContainerProps, ChatErrorViewProps } from '../error';

export function createChatLayoutView(
    config: ReportingShellViewBaseConfig & {
        Container: {
            Error: React.FC<ChatErrorContainerProps>;
        };
    }
): React.FC<ChatLayoutViewProps> {
    const {
        UI: {
            Application: { Anchor, Link, createErrorBoundary },
        },
        Container: { Error: ErrorContainer },
    } = config;
    const ErrorBoundary = createErrorBoundary({
        errorClass: Error,
    });
    const ErrorView: React.FC<ChatErrorViewProps> = (props) => {
        return (
            <HStack h="full" w="full" justify="center" align="center" py={8}>
                <Center w="full" h="full" pb={24}>
                    <VStack
                        maxW="24rem"
                        align="start"
                        p={6}
                        spacing={3}
                        // bg="whiteAlpha.50"
                        borderRadius="md"
                    >
                        <Icon w={8} h={8} color="red.500" as={AiOutlineWarning} />
                        <VStack align="start" color="whiteAlpha.900" spacing={1}>
                            <Text fontWeight="medium" letterSpacing="wide">
                                {props.title}
                            </Text>
                            <Text color="whiteAlpha.700">{props.description}</Text>
                        </VStack>
                        <ButtonGroup spacing={6}>
                            <Button
                                {...props.action.button}
                                variant="outline"
                                size="sm"
                                borderColor="whiteAlpha.300"
                                borderRadius="full"
                                bg="none"
                                // leftIcon={<Icon as={props.action.Icon} />}
                                _hover={{ bg: 'whiteAlpha.50' }}
                            >
                                {props.action.label}
                            </Button>
                        </ButtonGroup>
                    </VStack>
                </Center>
            </HStack>
        );
    };
    return (props) => {
        return (
            <Grid
                w="full"
                h="full"
                templateRows="min-content 1fr"
                fontSize={{ base: 'sm', '2xl': 'md' }}
            >
                <GridItem as={HStack} px={3} py={2} w="full" justify="space-between">
                    <HStack>
                        <HStack
                            bg="none"
                            _hover={{ bg: 'whiteAlpha.50' }}
                            py={0.5}
                            px={1}
                            borderRadius="md"
                            fontSize="sm"
                            fontWeight="semibold"
                            color="whiteAlpha.800"
                            cursor="default"
                        >
                            <Text noOfLines={1}>{props.title}</Text>
                        </HStack>
                    </HStack>
                    <HStack justify="end">
                        <IconButton
                            {...props.new.button}
                            aria-label="new thread"
                            size="sm"
                            bg="none"
                            _hover={{
                                bg: 'whiteAlpha.50',
                            }}
                            icon={
                                <Icon
                                    fontSize="md"
                                    color="whiteAlpha.600"
                                    as={AiOutlinePlus}
                                />
                            }
                        />
                        <IconButton
                            {...props.close.button}
                            aria-label="close"
                            size="sm"
                            bg="none"
                            _hover={{
                                bg: 'whiteAlpha.50',
                            }}
                            icon={
                                <Icon
                                    fontSize="sm"
                                    color="whiteAlpha.600"
                                    as={AiOutlineClose}
                                />
                            }
                        />
                    </HStack>
                </GridItem>
                <GridItem
                    pos="relative"
                    borderTopWidth={2}
                    borderColor="whiteAlpha.200"
                    w="full"
                >
                    <ErrorBoundary
                        key={props.error.hash}
                        fallback={(info) => <ErrorContainer as={ErrorView} info={info} />}
                    >
                        {props.children}
                    </ErrorBoundary>
                </GridItem>
            </Grid>
        );
    };
}
